import React from 'react';
import clsx from 'clsx';

import Icon from '../../../icons/Icon';

import scss from './MobileNavigation.module.scss';

function NavigationItem({
  label,
  icon,
  url,
  pathname,
  isStrokeIcon,
  selectedRoutes = [],
  disabled,
  onNavigate,
  isChild = false,
}) {
  const handleNavigate = () => {
    if (disabled) {
      return;
    }
    onNavigate(url);
  };

  return (
    <button
      type='button'
      className={clsx(
        scss.navLink,
        isChild && scss.navLinkChild,
        disabled && scss.navLinkDisabled,
        (pathname === url || selectedRoutes.includes(pathname)) && scss.navLinkActive,
      )}
      onClick={handleNavigate}
      disabled={disabled}
      aria-current={pathname === url || selectedRoutes.includes(pathname) ? 'page' : undefined}>
      <span className={scss.iconWrapper}>
        <Icon
          icon={icon}
          size={isChild ? 16 : 18}
          className={clsx(scss.icon, isStrokeIcon && scss.iconStroke)}
          disableCommonColors
        />
      </span>
      <span className={scss.label}>{label}</span>
    </button>
  );
}

export default NavigationItem;
